import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';

const TrackerRedirect = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set('section', 'tracker');
  return <Navigate to={`/profile?${params.toString()}`} replace />;
};

const TrackerPageRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <TrackerRedirect />
    </ProtectedRoute>
  );
};

export default TrackerPageRoute;
